/* eslint-disable no-redeclare */

import { z } from 'zod';

export const LeadStatus = z.enum([
  'FRESH2',
  'PURCHASE_COMPLETED',
  'PROSPECT',
  'SUBMITTED',
  'ENRICHED',
  'SCORED',
  'DELIVERED',
  'ROUTED',
]);

export type LeadStatus = z.infer<typeof LeadStatus>;
